import { CodingAgentChoiceController } from "../../views/coding-agent-choice/coding-agent-choice-controller";
import { JiraFflSetup } from "../../views/setup/jira/jira-ffl-setup";
import { ReactNode } from "react";

import { JiraAnimatedProvisioningScreen } from "../../views/jira/jira-animated-provisioning-screen/jira-animated-provisioning-screen";
import { JiraTemplateChoiceUfoWrapper } from "../../views/jira-template-choice/jira-choice-view-manager";
import JtbdView from "../../views/jtbd/jtbd-view";
import { OnboardingWizard } from "../../views/onboarding-wizard/onboarding-wizard";
import { ProductRedirector } from "../../views/product-redirector/product-redirector";
import ProjectLandingSelectorView from "../../views/project-landing-selector/project-landing-selector-view";
import { ResolveTenant } from "../../views/resolve-tenant";
import { JiraSetup } from "../../views/setup/jira";
import JiraUserSegmentationView from "../../views/user-seg-bxp-ui/user-segmentation";
import { PerceivedProvisioningStartTimer } from "../perceived-provisioning/perceived-provisioning-start-timer";

import {
    CODING_AGENT_CHOICE,
    JTBD,
    JIRA_FFL_PROJECT_SETUP,
    MADLIB_PROJECT_SETUP,
    PROJECT_LANDING_SELECTOR,
    PROVISIONING,
    PROVISIONING_WITH_WIZARD,
    ProvisioningScreenKey,
    RESOLVE_TENANT_LOADER,
    TEAM_CHOICE,
    TEMPLATE_CHOICE
} from "./utils";

export type ScreenList = ProvisioningScreenKey[];
export const madlibProjectSetupItem = {
    [MADLIB_PROJECT_SETUP]: <JiraSetup />
} as const;
export const jiraFflProjectSetupItem = {
    [JIRA_FFL_PROJECT_SETUP]: <JiraFflSetup />
} as const;
export const loadingDictionaryItem = {
    [RESOLVE_TENANT_LOADER]: <ResolveTenant />
} as const;
export const teamChoiceDictionaryItem = {
    [TEAM_CHOICE]: <JiraUserSegmentationView />
} as const;
export const templateChoiceDictionaryItem = {
    [TEMPLATE_CHOICE]: <JiraTemplateChoiceUfoWrapper />
} as const;
export const provisioningUIDictionaryItem = {
    [PROVISIONING]: (
        <PerceivedProvisioningStartTimer>
            <ProductRedirector>
                <JiraAnimatedProvisioningScreen />
            </ProductRedirector>
        </PerceivedProvisioningStartTimer>
    )
} as const;

export const provisioningWithOnboardingWizardDictionaryItem = {
    [PROVISIONING_WITH_WIZARD]: <OnboardingWizard />
};
export const jobsToBeDoneDictionaryItem = {
    [JTBD]: <JtbdView />
} as const;
export const codingAgentChoiceDictionaryItem = {
    [CODING_AGENT_CHOICE]: <CodingAgentChoiceController />
} as const;
export const projectLandingSelectorDictionaryItem = {
    [PROJECT_LANDING_SELECTOR]: <ProjectLandingSelectorView />
} as const;
export type ScreenDictionary = Partial<
    Record<ProvisioningScreenKey, ReactNode>
>;

// @todo add the feature flagging as part of config
// lists the supported screens for Jira signups
export const jiraScreenDictionary: ScreenDictionary = {
    ...jiraFflProjectSetupItem,
    ...loadingDictionaryItem,
    ...teamChoiceDictionaryItem,
    ...templateChoiceDictionaryItem,
    ...provisioningUIDictionaryItem,
    ...provisioningWithOnboardingWizardDictionaryItem,
    ...jobsToBeDoneDictionaryItem,
    ...codingAgentChoiceDictionaryItem,
    ...projectLandingSelectorDictionaryItem,
    ...madlibProjectSetupItem
};
